import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Pagination } from "react-bootstrap";
import {
  query,
  endAt,
  setDoc,
  getDocs,
  collection,
  orderBy,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  startAt,
  getCountFromServer,
  doc,
  deleteDoc,
  updateDoc,
  getDoc,
  where,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../../firebase";

const TicketItem = ({
  tickets,
  onEdit,
  onDelete,
  onNext,
  onPrev,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  onViewFile,
  goToPage, // add goToPage
  isStart, // add isStart
  isEnd, // add isEnd
  getNext, // add getNext
  getPrev, // add getPrev
}) => {
  const [loading, setLoading] = useState(false);

  const numberPagination = Array(Math.ceil(totalItems / itemsPerPage))
    .fill()
    .map((_, i) => i + 1);

  const handleDate = (date) => {
    if (date != undefined) {
      try {
        var datetime = new Date(date.toDate()).toLocaleDateString();

        return datetime;
      } catch {
        var newDate = new Date(date);
        var hours = newDate.getHours() + 7;
        newDate = new Date(newDate.setHours(hours));
        var newString = newDate.toLocaleDateString();

        return newString;
      }
    } else {
      return "";
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table mb-0 table-striped">
                  <thead>
                    <tr>
                      <th> </th>
                      <th>Ticket Type</th>
                      <th>SN</th>
                      {/* <th>Problem</th> */}
                      <th>Due Date</th>
                      <th>Request By</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody id="tickets-table">
                    {!loading ? (
                      tickets.map((item, index) => {
                        var variantData = "";
                        var newDateOptions = {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        };

                        if (item.ticketType == "แจ้งซ่อม") {
                          variantData = "danger dark";
                        } else if (item.ticketType == "อื่นๆ") {
                          variantData = "danger dark";
                        }

                        var variantActivity = "";
                        if (item.ticketStatus === "รอดำเนินการ") {
                          variantActivity = "info dark";
                        } else if (item.ticketStatus === "กำลังดำเนินการ") {
                          variantActivity = "info light";
                        } else if (item.ticketStatus === "ดำเนินการเสร็จสิ้น") {
                          variantActivity = "success light";
                        }
                        return (
                          <tr className="btn-reveal-trigger">
                            <td className="py-1">
                              {index + 1 + (currentPage - 1) * itemsPerPage}
                            </td>
                            <td className="py-2">{item.ticketType}</td>

                            <td className="py-2">
                              <Link to={"/equipment-page/" + item.equipmentId}>
                                {item.sn}
                              </Link>
                            </td>
                            {/* <td className="py-2">{item.problem}</td> */}

                            {/* <td className="py-2">
                              {item.image.map((i, idx) => (
                                <Link
                                  key={idx}
                                  to="#"
                                  onClick={() => onViewFile(item.ticketId, i)}
                                >
                                  {i}
                                </Link>
                              ))}
                            </td> */}

                            <td className="py-2">{handleDate(item.dueDate)}</td>

                            <td className="py-2">{item.createdBy}</td>
                            <td className="py-2">
                              <Badge variant={variantActivity}>
                                {item.ticketStatus}
                              </Badge>
                            </td>
                            <td className="py-2 text-right">
                              <div className="d-flex">
                                <Link
                                  className="btn btn-info shadow btn-xs sharp mr-2"
                                  to="#"
                                  onClick={() => onEdit(item.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Edit equipment details"
                                >
                                  <i className="fa fa-pencil"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => onDelete(item.id, item.image)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Delete equipment"
                                >
                                  <i className="fa fa-trash"></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <div class="media d-flex align-items-center">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      </div>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {totalItems < currentPage * itemsPerPage
                    ? totalItems
                    : currentPage * itemsPerPage}{" "}
                  of {totalItems} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <Pagination
                    className="pagination-primary pagination-circle"
                    size="lg"
                  >
                    <Pagination.Prev onClick={getPrev} disabled={isStart} />
                    {/* <li className="page-item page-indicator " onClick={onPrev}>
                      <Link className="page-link" to="#">
                        <i className="la la-angle-left" />
                      </Link>
                    </li> */}
                    {pageNumbers.map((number) => (
                      <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => goToPage(number)}
                      >
                        {number}
                      </Pagination.Item>
                    ))}

                    {/* {numberPagination.map((number, i) => (
                      <Pagination.Item
                        className={currentPage === i ? "active" : ""}
                        disabled
                      >
                        {number}
                      </Pagination.Item>
                    ))} */}
                    {/* <li className="page-item page-indicator" onClick={onNext}>
                      <Link className="page-link" to="#">
                        <i className="la la-angle-right" />
                      </Link>
                    </li> */}
                    <Pagination.Next onClick={getNext} disabled={isEnd} />
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TicketItem;
